import { BuildingRegulatoryInfoDTO } from "shared/types/regulatory-info";
import { API_URL } from "constants/index";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { BuildingDTO } from "shared/types/building";

export const calculateCadastreStatusDotValues = async (cadastreInfo: BuildingRegulatoryInfoDTO, building: BuildingDTO, session: any) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    // Cadastral Income
    if (cadastreInfo.cadastralIncome) {
        dotValues.green.count++;
        dotValues.green.labels.push("Kadastraal inkomen ingevuld");
    } else {
        dotValues.red.count++;
        dotValues.red.labels.push("Kadastraal inkomen niet ingevuld");
    }

    // Fetch and check cadastre-related file logs
    try {
        const queryParams = new URLSearchParams();
        if (building?.id) {
            queryParams.append('buildingId', building.id);
        }

        const labels = [
            "Plan kadaster",
            "Kadstraal inkomen", 
            "Kadastraal uittreksel",
            "Aanslagbiljet onroerende voorheffing"
        ];
        queryParams.append('labels', labels.join(','));

        const response = await fetchWithAuth(
            `${API_URL}/file/get-file-logs?${queryParams.toString()}`,
            { method: 'GET' },
            session
        );
        const fileLogs = await response.json();
        
        // Check for each document type
        const planKadasterExists = fileLogs.some((log: any) => log.label.includes("Plan kadaster"));
        const kadastraalInkomenExists = fileLogs.some((log: any) => log.label.includes("Kadstraal inkomen"));
        const kadastraalUittrekselExists = fileLogs.some((log: any) => log.label.includes("Kadastraal uittreksel"));
        const aanslagbiljetExists = fileLogs.some((log: any) => log.label.includes("Aanslagbiljet onroerende voorheffing"));
        
        // Add green dots for documents that exist
        if (planKadasterExists) {
            dotValues.green.count++;
            dotValues.green.labels.push("Plan kadaster aanwezig");
        }
        
        if (kadastraalInkomenExists) {
            dotValues.green.count++;
            dotValues.green.labels.push("Kadstraal inkomen document aanwezig");
        }
        
        if (kadastraalUittrekselExists) {
            dotValues.green.count++;
            dotValues.green.labels.push("Kadastraal uittreksel aanwezig");
        } else {
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Geen kadastraal uittreksel aanwezig");
        }
        
        if (aanslagbiljetExists) {
            dotValues.green.count++;
            dotValues.green.labels.push("Aanslagbiljet onroerende voorheffing aanwezig");
        } else {
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Geen aanslagbiljet onroerende voorheffing aanwezig");
        }
        
    } catch (error) {
        console.error('Error fetching cadastre document logs:', error);
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Fout bij ophalen kadastrale documenten");
    }

    return dotValues;
};
